module.exports = __webpack_public_path__ + "img/iconopantalon.01d329d7.png";